import React from 'react';

import styles from './formButtonsStyles';
import classNames from 'classnames';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

const FormButtons = ({ dirty, onCancel, isSubmitting, hasErrors, alignRight, hideSubmit }) => {
  const formButtonsClass = classNames(styles.formButtons, {
    [`${styles.alignRight}`]: alignRight
  });

  return (
    <div className={formButtonsClass}>
      {dirty && !hideSubmit ? (
        <>
          <Button isLoading={isSubmitting} text="Save Changes" type={BUTTON_TYPES.PRIMARY} />
          <Button
            buttonType={BUTTON_TYPES.BUTTON}
            disabled={isSubmitting}
            onClick={onCancel}
            text="Cancel"
            type={BUTTON_TYPES.SECONDARY}
          />
        </>
      ) : (
        <Button
          buttonType={BUTTON_TYPES.BUTTON}
          onClick={onCancel}
          text="Close"
          type={BUTTON_TYPES.SECONDARY}
        />
      )}
      {hasErrors && <span className={styles.errors}>Please fix all errors before submission.</span>}
    </div>
  );
};

export default FormButtons;
